package com.wintermar.inspection.feature.domain.model.inspection

/**
 * Result of synchronizing inspections between API and local database.
 *
 * @param removedInspectionIds List of inspection IDs that were removed from local database
 *        because they no longer exist in the remote source
 */
data class SyncInspectionsResult(
    val removedInspectionIds: List<String> = emptyList()
)
